// src/pages/JnanaDeepamPage.jsx
import React from "react";
import JnanaDeepam from "../components/jnanadeepam/JnanaDeepam";

export default function JnanaDeepamPage({ defaultTab }) {
  return (
    <div>
      <JnanaDeepam defaultTab={defaultTab} />
    </div>
  );
}
